<template>
  <div class="d-flex align-center">
    <v-text-field
      background-color="#fff"
      v-model="searchTerm"
      id="search"
      dense
      outlined
      hide-details="auto"
      :placeholder="placeholder"
      @input="search"
      class="table-search__search"
    >
      <template v-slot:[`append`]>
        <apio-icon size="24" name="ui-search" />
      </template>
    </v-text-field>
  </div>
</template>

<script>
export default {
  name: 'TableSearch',
  props: {
    placeholder: {
      type: String,
      default: 'Start searching...',
    },
    tableSearchIcon: {
      type: String,
      default: 'fa-search',
    }
  },
  data() {
    return {
      searchTerm: '',
    }
  },
  methods: {
    search() {
      this.$emit('search', this.searchTerm);
    }
  }
}
</script>

<style lang="scss"  scoped>

.table-search {
    &__search {
      width: 200px;
    }
  }

@media (max-width: 768px) {
  .table-search {
    &__search {
      width: calc(100vw - 40px);
    }
  }
}

</style>
